// GENERATED by make_words.py — force-aligned (global CTC). Do not hand-edit.
export const DUR = 543.688;
/** every spoken word: [start, end, text] — indexed so type can land word by word */
export const WD: [number,number,string][] = [
  [0.3,0.58,"बच्चे"],
  [0.66,0.741,"का"],
  [0.841,1.041,"जन्म"],
  [1.141,1.221,"हो,"],
  [1.581,1.961,"मुंडन"],
  [2.041,2.121,"हो,"],
  [2.402,2.682,"शादी"],
  [2.782,2.862,"हो,"],
  [3.282,3.442,"गृह"],
  [3.542,3.903,"प्रवेश"],
  [3.943,4.023,"हो,"],
  [4.263,4.523,"हवन"],
  [4.583,4.643,"हो,"],
  [5.023,5.103,"या"],
  [5.204,5.424,"किसी"],
  [5.484,5.724,"अपने"],
  [5.764,5.844,"का"],
  [5.944,6.224,"अंतिम"],
  [6.284,6.765,"संस्कार।"],
  [7.225,7.385,"हर"],
  [7.445,7.705,"बार,"],
  [7.985,8.266,"सबसे"],
  [8.326,8.586,"पहले,"],
  [8.686,8.986,"पंडित"],
  [9.066,9.146,"जी"],
  [9.306,9.426,"एक"],
  [9.486,9.566,"ही"],
  [9.627,9.887,"सवाल"],
  [9.927,10.227,"पूछते"],
  [10.267,10.347,"हैं।"],
  [10.687,11.027,"आपका"],
  [11.128,11.428,"गोत्र"],
  [11.488,11.608,"क्या"],
  [11.688,11.748,"है।"],
  [12.228,12.348,"और"],
  [12.428,12.589,"हम"],
  [12.629,12.789,"में"],
  [12.829,12.909,"से"],
  [12.909,13.489,"ज़्यादातर"],
  [13.529,13.729,"लोग"],
  [13.949,14.17,"उसी"],
  [14.27,14.41,"पल"],
  [14.53,14.71,"घर"],
  [14.79,14.93,"फ़ोन"],
  [14.95,15.29,"लगाते"],
  [15.33,15.43,"हैं।"],
  [15.951,16.011,"तो"],
  [16.131,16.391,"आज"],
  [16.471,16.711,"सीधे"],
  [16.791,16.971,"काम"],
  [17.032,17.092,"की"],
  [17.132,17.372,"बात।"],
  [17.672,17.972,"गोत्र"],
  [18.092,18.352,"होता"],
  [18.432,18.533,"क्या"],
  [18.593,18.673,"है।"],
  [19.053,19.173,"और"],
  [19.173,19.433,"इसके"],
  [19.513,19.773,"साथ"],
  [19.893,19.974,"दो"],
  [20.134,20.334,"शब्द"],
  [20.474,20.634,"और"],
  [20.714,20.954,"चलते"],
  [20.994,21.154,"हैं,"],
  [21.254,21.595,"प्रवर"],
  [21.595,21.915,"और"],
  [22.015,22.395,"सपिंड।"],
  [22.755,22.915,"ये"],
  [22.996,23.276,"दोनों"],
  [23.316,23.436,"क्या"],
  [23.516,23.596,"हैं,"],
  [23.656,24.236,"इनका"],
  [24.316,24.677,"महत्व"],
  [24.737,24.857,"क्या"],
  [24.917,24.997,"है,"],
  [25.437,25.697,"शादी"],
  [25.757,25.857,"में"],
  [25.998,26.278,"असल"],
  [26.298,26.378,"में"],
  [26.478,26.618,"क्या"],
  [26.698,26.998,"मिलाया"],
  [27.058,27.298,"जाता"],
  [27.318,27.399,"है,"],
  [27.719,27.879,"और"],
  [27.879,28.059,"इस"],
  [28.059,28.319,"सबमें"],
  [28.319,28.86,"विज्ञान"],
  [28.9,29.16,"कितना"],
  [29.2,29.28,"है।"],
  [29.94,30.22,"सबसे"],
  [30.26,30.501,"पहले"],
  [30.621,30.701,"वह"],
  [30.821,31.081,"बात"],
  [31.181,31.241,"जो"],
  [31.341,31.481,"इस"],
  [31.581,31.802,"पूरे"],
  [31.802,32.102,"विषय"],
  [32.182,32.242,"की"],
  [32.362,32.562,"जड़"],
  [32.582,32.662,"है।"],
  [33.182,33.483,"गोत्र"],
  [33.583,33.743,"एक"],
  [33.843,34.063,"शब्द"],
  [34.103,34.183,"है,"],
  [34.483,34.643,"पर"],
  [34.643,34.884,"इसके"],
  [34.924,35.204,"नीचे"],
  [35.324,35.404,"दो"],
  [35.584,35.824,"अलग"],
  [35.844,36.305,"व्यवस्थाएँ"],
  [36.365,36.585,"चलती"],
  [36.645,36.805,"हैं।"],
  [37.045,37.205,"और"],
  [37.305,37.565,"दोनों"],
  [37.685,37.966,"असली"],
  [38.046,38.146,"हैं।"],
  [38.706,38.966,"पहली"],
  [39.046,39.427,"व्यवस्था"],
  [39.527,39.607,"को"],
  [39.787,40.087,"आर्ष"],
  [40.127,40.347,"गोत्र"],
  [40.407,40.668,"कहते"],
  [40.708,40.788,"हैं।"],
  [41.228,41.568,"आर्ष"],
  [41.588,41.808,"यानी"],
  [42.028,42.309,"रिषि"],
  [42.349,42.429,"से"],
  [42.429,42.649,"जुड़ा"],
  [42.709,42.869,"हुआ।"],
  [43.469,43.71,"अपने"],
  [43.81,44.01,"पिता"],
  [44.11,44.17,"को"],
  [44.21,44.49,"लीजिए।"],
  [44.79,44.93,"फिर"],
  [44.93,45.251,"उनके"],
  [45.331,45.531,"पिता।"],
  [45.791,45.931,"फिर"],
  [46.011,46.251,"उनके"],
  [46.311,46.511,"पिता।"],
  [46.892,47.032,"इस"],
  [47.112,47.372,"सीधी"],
  [47.412,47.672,"रेखा"],
  [47.752,47.832,"को"],
  [47.952,48.233,"पीछे"],
  [48.273,48.353,"ले"],
  [48.433,48.653,"जाते"],
  [48.653,48.933,"जाइए,"],
  [49.273,49.333,"तो"],
  [49.453,49.533,"यह"],
  [49.674,49.854,"एक"],
  [49.914,50.214,"रिषि"],
  [50.234,50.334,"पर"],
  [50.374,50.654,"जाकर"],
  [50.674,50.934,"रुकती"],
  [50.994,51.055,"है।"],
  [51.475,51.655,"उस"],
  [51.695,51.935,"रिषि"],
  [52.015,52.095,"का"],
  [52.155,52.395,"नाम"],
  [52.455,52.516,"ही"],
  [52.696,52.976,"आपका"],
  [53.116,53.416,"गोत्र"],
  [53.476,53.536,"है।"],
  [54.137,54.717,"भारद्वाज"],
  [54.777,55.037,"गोत्र"],
  [55.097,55.157,"का"],
  [55.197,55.558,"मतलब"],
  [55.598,55.658,"है,"],
  [55.898,56.198,"आपका"],
  [56.258,56.678,"परिवार"],
  [56.778,57.379,"भारद्वाज"],
  [57.419,57.639,"रिषि"],
  [57.719,57.779,"से"],
  [57.839,58.019,"गिना"],
  [58.079,58.299,"जाता"],
  [58.339,58.42,"है।"],
  [58.9,59.26,"कश्यप"],
  [59.3,59.58,"गोत्र"],
  [59.64,59.84,"यानी"],
  [59.901,60.381,"कश्यप"],
  [60.381,60.601,"रिषि"],
  [60.701,60.781,"से।"],
  [61.422,61.722,"दूसरी"],
  [61.742,62.182,"व्यवस्था"],
  [62.282,62.342,"को"],
  [62.482,62.802,"लौकिक"],
  [62.863,63.103,"गोत्र"],
  [63.163,63.423,"कहते"],
  [63.463,63.563,"हैं।"],
  [63.943,64.344,"लौकिक"],
  [64.344,64.584,"यानी"],
  [64.724,64.984,"लोक"],
  [65.084,65.164,"का,"],
  [65.504,65.885,"समाज"],
  [65.945,66.025,"का,"],
  [66.365,66.885,"रोज़मर्रा"],
  [66.985,67.045,"के"],
  [67.045,67.566,"व्यवहार"],
  [67.646,67.726,"का।"],
  [68.186,68.386,"यहाँ"],
  [68.506,68.787,"गोत्र"],
  [68.867,69.047,"किसी"],
  [69.127,69.347,"रिषि"],
  [69.407,69.467,"के"],
  [69.547,69.747,"नाम"],
  [69.807,69.867,"से"],
  [69.887,70.067,"नहीं"],
  [70.107,70.328,"होते।"],
  [70.788,70.968,"यहाँ"],
  [71.108,71.188,"वह"],
  [71.288,71.488,"नाम"],
  [71.508,71.749,"होता"],
  [71.829,71.909,"है"],
  [72.029,72.249,"किसी"],
  [72.309,72.589,"पुरखे"],
  [72.689,72.769,"का,"],
  [73.109,73.27,"किसी"],
  [73.39,73.59,"गाँव"],
  [73.67,73.75,"का,"],
  [74.05,74.23,"किसी"],
  [74.35,74.57,"काम"],
  [74.65,74.731,"का,"],
  [74.991,75.071,"या"],
  [75.151,75.311,"किसी"],
  [75.451,75.671,"वंश"],
  [75.751,75.831,"का।"],
  [76.131,76.232,"और"],
  [76.272,76.392,"यह"],
  [76.492,76.692,"पूरी"],
  [76.792,76.992,"तरह"],
  [77.152,77.392,"वैध"],
  [77.452,77.713,"गोत्र"],
  [77.773,77.833,"है।"],
  [78.493,78.713,"तीन"],
  [78.773,79.073,"बातें"],
  [79.134,79.374,"दोनों"],
  [79.394,79.514,"पर"],
  [79.554,79.794,"लागू"],
  [79.834,80.054,"होती"],
  [80.114,80.214,"हैं।"],
  [80.655,80.935,"पहली,"],
  [81.295,81.375,"यह"],
  [81.515,81.815,"सिर्फ़"],
  [81.815,82.015,"पिता"],
  [82.096,82.176,"से"],
  [82.276,82.516,"पुत्र"],
  [82.556,82.656,"तक"],
  [82.716,82.976,"चलता"],
  [83.036,83.116,"है।"],
  [83.496,83.637,"माँ"],
  [83.757,83.817,"की"],
  [83.817,84.137,"तरफ़"],
  [84.197,84.277,"से"],
  [84.417,84.497,"यह"],
  [84.577,84.857,"रेखा"],
  [84.977,85.198,"आगे"],
  [85.278,85.498,"नहीं"],
  [85.498,85.798,"बढ़ती।"],
  [86.398,86.839,"दूसरी,"],
  [87.099,87.179,"यह"],
  [87.319,87.679,"सरनेम"],
  [87.759,87.819,"से"],
  [87.819,88.14,"अलग"],
  [88.24,88.46,"चीज़"],
  [88.46,88.54,"है।"],
  [89.0,89.16,"एक"],
  [89.22,89.28,"ही"],
  [89.38,89.721,"सरनेम"],
  [89.781,89.981,"वाले"],
  [90.081,90.161,"दो"],
  [90.281,90.741,"परिवारों"],
  [90.781,90.841,"के"],
  [90.942,91.202,"गोत्र"],
  [91.342,91.622,"अलग"],
  [91.622,91.662,"हो"],
  [91.742,92.002,"सकते"],
  [92.042,92.142,"हैं।"],
  [92.683,93.003,"तीसरी,"],
  [93.383,93.463,"यह"],
  [93.603,93.883,"जाति"],
  [93.944,94.024,"से"],
  [94.084,94.144,"भी"],
  [94.204,94.404,"अलग"],
  [94.484,94.684,"चीज़"],
  [94.704,94.764,"है।"],
  [95.244,95.405,"एक"],
  [95.465,95.545,"ही"],
  [95.625,95.885,"जाति"],
  [95.945,96.005,"के"],
  [96.085,96.365,"भीतर"],
  [96.505,96.825,"सैकड़ों"],
  [96.886,97.126,"गोत्र"],
  [97.166,97.426,"मिलते"],
  [97.486,97.666,"हैं,"],
  [97.886,97.986,"और"],
  [98.126,98.286,"एक"],
  [98.347,98.427,"ही"],
  [98.507,98.747,"गोत्र"],
  [98.807,98.907,"का"],
  [98.947,99.167,"नाम"],
  [99.287,99.747,"अलग-अलग"],
  [99.828,100.188,"जातियों"],
  [100.208,100.308,"में"],
  [100.368,100.428,"भी"],
  [100.548,100.708,"मिल"],
  [100.788,101.028,"जाता"],
  [101.088,101.168,"है।"],
  [101.729,101.849,"अब"],
  [101.949,102.209,"पहली"],
  [102.269,102.669,"व्यवस्था"],
  [102.749,102.81,"को"],
  [102.91,103.25,"खोलते"],
  [103.31,103.49,"हैं।"],
  [103.79,104.09,"आर्ष"],
  [104.13,104.411,"गोत्र।"],
  [104.971,105.451,"बौधायन"],
  [105.531,105.792,"श्रौत"],
  [105.872,106.112,"सूत्र"],
  [106.152,106.292,"में"],
  [106.392,106.632,"सात"],
  [106.632,106.832,"रिषि"],
  [106.912,107.152,"गिनाए"],
  [107.213,107.353,"गए"],
  [107.393,107.573,"हैं,"],
  [107.813,107.913,"और"],
  [108.033,108.413,"आठवें"],
  [108.473,108.934,"अगस्त्य।"],
  [109.414,109.594,"इन्हें"],
  [109.714,110.235,"गोत्रकार"],
  [110.255,110.535,"रिषि"],
  [110.555,110.815,"कहते"],
  [110.875,110.955,"हैं।"],
  [111.415,111.916,"गोत्रकार"],
  [111.976,112.176,"यानी"],
  [112.336,112.396,"वे"],
  [112.816,113.076,"जिनके"],
  [113.157,113.377,"नाम"],
  [113.437,113.517,"से"],
  [113.637,113.937,"गोत्र"],
  [113.977,114.037,"की"],
  [114.157,114.397,"गिनती"],
  [114.537,114.718,"शुरू"],
  [114.758,114.958,"मानी"],
  [115.038,115.258,"जाती"],
  [115.338,115.418,"है।"],
  [115.998,116.259,"यहीं"],
  [116.279,116.399,"पर"],
  [116.539,116.819,"सबसे"],
  [116.819,117.059,"बड़ी"],
  [117.079,117.72,"ग़लतफ़हमी"],
  [117.8,118.04,"बैठी"],
  [118.12,118.2,"है।"],
  [118.66,118.92,"लोग"],
  [118.92,119.081,"इसे"],
  [119.201,119.521,"गोत्रों"],
  [119.561,119.621,"की"],
  [119.741,119.881,"कुल"],
  [119.961,120.281,"संख्या"],
  [120.341,120.582,"समझ"],
  [120.602,120.822,"लेते"],
  [120.882,120.982,"हैं।"],
  [121.482,121.582,"यह"],
  [121.702,122.023,"संख्या"],
  [122.063,122.443,"गोत्र"],
  [122.443,122.903,"बनाने"],
  [123.003,123.223,"वाले"],
  [123.283,123.604,"रिषियों"],
  [123.664,123.724,"की"],
  [123.804,123.884,"है।"],
  [124.504,124.804,"गोत्र"],
  [124.884,125.145,"कितने"],
  [125.225,125.405,"हैं,"],
  [125.485,125.765,"इसका"],
  [125.825,126.125,"जवाब"],
  [126.125,126.466,"उसी"],
  [126.506,126.946,"बौधायन"],
  [127.006,127.066,"के"],
  [127.166,127.426,"ग्रंथ"],
  [127.466,127.606,"में"],
  [127.686,127.927,"अगली"],
  [127.987,128.047,"ही"],
  [128.187,128.427,"साँस"],
  [128.447,128.567,"में"],
  [128.567,128.787,"लिखा"],
  [128.847,128.927,"है।"],
  [129.408,129.848,"हज़ारों,"],
  [130.208,130.588,"लाखों,"],
  [130.869,130.989,"और"],
  [131.089,131.349,"उससे"],
  [131.409,131.469,"भी"],
  [131.589,131.789,"आगे।"],
  [132.41,132.63,"यानी"],
  [132.79,133.03,"आठ"],
  [133.09,133.31,"नाम"],
  [133.43,133.73,"गोत्र"],
  [133.79,134.131,"बनाने"],
  [134.171,134.371,"वाले"],
  [134.411,134.731,"रिषियों"],
  [134.791,134.851,"के"],
  [134.911,135.131,"हैं।"],
  [135.452,135.792,"गोत्रों"],
  [135.852,135.912,"की"],
  [136.032,136.272,"अपनी"],
  [136.372,136.632,"गिनती"],
  [136.752,136.953,"कभी"],
  [136.993,137.193,"नहीं"],
  [137.253,137.493,"बंधी।"],
  [137.853,137.973,"और"],
  [137.973,138.213,"आपके"],
  [138.294,138.434,"घर"],
  [138.454,138.554,"में"],
  [138.614,138.674,"जो"],
  [138.754,138.954,"नाम"],
  [138.994,139.194,"बोला"],
  [139.254,139.474,"जाता"],
  [139.534,139.594,"है,"],
  [139.895,139.955,"वह"],
  [140.075,140.475,"आमतौर"],
  [140.515,140.635,"पर"],
  [140.695,140.875,"किसी"],
  [140.995,141.236,"शाखा"],
  [141.296,141.376,"का"],
  [141.416,141.636,"होता"],
  [141.676,141.756,"है।"],
  [142.176,142.777,"आश्वलायन"],
  [142.877,143.137,"श्रौत"],
  [143.177,143.477,"सूत्र"],
  [143.477,143.537,"के"],
  [143.537,143.957,"अनुसार"],
  [144.238,144.598,"वसिष्ठ"],
  [144.658,144.718,"के"],
  [144.738,144.998,"नीचे"],
  [145.298,145.779,"पराशर"],
  [145.839,145.959,"और"],
  [146.039,146.499,"कौंडिन्य"],
  [146.499,146.699,"आते"],
  [146.759,146.839,"हैं।"],
  [147.26,147.38,"अब"],
  [147.44,147.72,"दूसरी"],
  [147.72,148.14,"व्यवस्था।"],
  [148.52,148.841,"लौकिक"],
  [148.921,149.201,"गोत्र।"],
  [149.481,149.601,"और"],
  [149.601,149.761,"इसे"],
  [149.821,150.142,"समझने"],
  [150.222,150.282,"के"],
  [150.302,150.442,"लिए"],
  [150.682,150.822,"एक"],
  [150.882,151.162,"असली"],
  [151.242,151.442,"सूची"],
  [151.502,151.783,"देखते"],
  [151.823,151.923,"हैं।"],
  [152.483,152.743,"मैढ़"],
  [152.783,153.204,"क्षत्रिय"],
  [153.304,153.784,"स्वर्णकार"],
  [153.844,154.144,"समाज"],
  [154.164,154.244,"की"],
  [154.324,154.605,"गोत्र"],
  [154.665,154.885,"सूची"],
  [154.925,155.205,"लीजिए।"],
  [155.585,155.845,"उसमें"],
  [155.905,156.166,"कॉलम"],
  [156.246,156.346,"इस"],
  [156.386,156.546,"तरह"],
  [156.626,156.786,"बने"],
  [156.826,156.926,"हैं।"],
  [157.346,157.647,"गोत्र,"],
  [157.987,158.227,"नख,"],
  [158.487,158.927,"निकास,"],
  [159.148,159.448,"पुरखा,"],
  [159.708,159.828,"और"],
  [159.908,160.288,"कुलदेवी।"],
  [160.929,161.149,"नख"],
  [161.189,161.389,"यानी"],
  [161.509,161.649,"कुल"],
  [161.709,161.769,"की"],
  [161.869,162.15,"शाखा।"],
  [162.57,162.93,"निकास"],
  [162.97,163.17,"यानी"],
  [163.17,163.37,"वह"],
  [163.471,163.691,"जगह"],
  [163.991,164.191,"जहाँ"],
  [164.251,164.331,"से"],
  [164.371,164.491,"वह"],
  [164.551,164.691,"कुल"],
  [164.711,164.992,"निकला।"],
  [165.412,165.692,"पुरखा"],
  [165.772,165.972,"यानी"],
  [165.972,166.172,"वह"],
  [166.292,166.653,"पूर्वज"],
  [166.893,167.153,"जिसके"],
  [167.193,167.393,"नाम"],
  [167.433,167.513,"से"],
  [167.553,167.653,"यह"],
  [167.653,167.974,"गोत्र"],
  [168.054,168.234,"चला।"],
  [168.554,168.654,"और"],
  [168.734,169.134,"कुलदेवी"],
  [169.415,169.615,"यानी"],
  [169.715,169.855,"उस"],
  [169.895,170.035,"कुल"],
  [170.115,170.195,"की"],
  [170.295,170.535,"अपनी"],
  [170.615,170.816,"देवी।"],
  [171.396,171.696,"उसमें"],
  [171.736,171.856,"एक"],
  [171.936,172.176,"गोत्र"],
  [172.236,172.297,"है"],
  [172.417,172.877,"कटारिया।"],
  [173.217,173.437,"उसके"],
  [173.557,173.737,"आगे"],
  [173.778,173.998,"लिखा"],
  [174.078,174.138,"है।"],
  [174.498,174.678,"नख"],
  [174.778,175.198,"चौहान।"],
  [175.479,175.859,"निकास"],
  [175.939,176.319,"सांभर।"],
  [176.599,176.9,"पुरखा"],
  [177.14,177.6,"कटारजी।"],
  [177.94,178.341,"कुलदेवी"],
  [178.441,178.681,"दुर्गा।"],
  [179.241,179.682,"कटारजी"],
  [179.762,179.822,"से"],
  [179.902,180.322,"कटारिया।"],
  [180.682,180.922,"नाम"],
  [181.002,181.283,"पुरखे"],
  [181.343,181.423,"का"],
  [181.503,181.563,"है।"],
  [182.103,182.203,"और"],
  [182.223,182.303,"उस"],
  [182.383,182.583,"पूरी"],
  [182.684,182.924,"सूची"],
  [182.984,183.064,"में"],
  [183.344,183.584,"रिषि"],
  [183.624,183.704,"का"],
  [183.804,183.944,"कोई"],
  [184.024,184.245,"कॉलम"],
  [184.265,184.465,"नहीं"],
  [184.525,184.585,"है।"],
  [184.925,185.185,"प्रवर"],
  [185.245,185.325,"का"],
  [185.385,185.465,"भी"],
  [185.485,185.686,"नहीं।"],
  [186.006,186.246,"क्योंकि"],
  [186.326,186.386,"यह"],
  [186.506,186.646,"उस"],
  [186.666,186.826,"तरह"],
  [186.926,186.986,"की"],
  [187.067,187.307,"सूची"],
  [187.327,187.507,"नहीं"],
  [187.567,187.647,"है।"],
  [188.167,188.367,"एक"],
  [188.427,188.608,"बात"],
  [188.668,188.868,"साफ़"],
  [188.888,189.008,"कह"],
  [189.048,189.248,"देते"],
  [189.308,189.388,"हैं।"],
  [189.828,189.988,"यह"],
  [190.029,190.269,"सूची"],
  [190.389,190.709,"समाज"],
  [190.749,190.809,"की"],
  [190.929,191.149,"अपनी"],
  [191.229,191.289,"है,"],
  [191.65,191.75,"और"],
  [191.75,191.79,"वह"],
  [191.79,192.17,"ख़ुद"],
  [192.17,192.43,"लिखती"],
  [192.51,192.57,"है"],
  [192.83,192.89,"कि"],
  [192.89,193.131,"इस"],
  [193.171,193.291,"पर"],
  [193.371,193.551,"काम"],
  [193.631,193.771,"अभी"],
  [193.891,194.031,"चल"],
  [194.051,194.231,"रहा"],
  [194.311,194.371,"है।"],
  [194.872,194.952,"यह"],
  [195.072,195.312,"गोत्र"],
  [195.412,195.672,"कितना"],
  [195.732,196.053,"पुराना"],
  [196.113,196.173,"है,"],
  [196.453,196.693,"इसका"],
  [196.693,196.973,"कोई"],
  [197.093,197.554,"शिलालेख"],
  [197.734,197.834,"या"],
  [197.914,198.294,"सरकारी"],
  [198.374,198.895,"दस्तावेज़"],
  [198.915,199.075,"हमें"],
  [199.115,199.295,"नहीं"],
  [199.335,199.495,"मिला।"],
  [199.835,199.955,"हम"],
  [200.055,200.195,"वही"],
  [200.235,200.496,"बता"],
  [200.516,200.696,"रहे"],
  [200.756,200.896,"हैं"],
  [200.916,200.976,"जो"],
  [201.096,201.316,"दर्ज"],
  [201.336,201.416,"है।"],
  [202.017,202.437,"इसीलिए"],
  [202.697,202.917,"अगर"],
  [202.997,203.277,"आपका"],
  [203.378,203.618,"गोत्र"],
  [203.678,203.918,"रिषि"],
  [203.998,204.058,"के"],
  [204.098,204.378,"नामों"],
  [204.378,204.478,"में"],
  [204.538,204.718,"कहीं"],
  [204.758,204.959,"नहीं"],
  [205.019,205.339,"बैठता,"],
  [205.599,205.659,"तो"],
  [205.739,205.819,"वह"],
  [205.919,206.099,"किसी"],
  [206.199,206.42,"सूची"],
  [206.48,206.56,"से"],
  [206.64,206.88,"बाहर"],
  [206.9,207.08,"नहीं"],
  [207.14,207.2,"है।"],
  [207.58,207.66,"वह"],
  [207.821,208.101,"दूसरी"],
  [208.101,208.401,"सूची"],
  [208.461,208.541,"का"],
  [208.601,208.681,"है।"],
  [209.121,209.262,"अब"],
  [209.302,209.382,"वो"],
  [209.562,209.642,"दो"],
  [209.842,210.062,"शब्द"],
  [210.122,210.202,"जो"],
  [210.362,210.622,"गोत्र"],
  [210.682,210.743,"के"],
  [210.883,211.123,"साथ"],
  [211.123,211.203,"ही"],
  [211.243,211.503,"चलते"],
  [211.543,211.643,"हैं।"],
  [211.963,212.244,"पहला,"],
  [212.544,212.864,"प्रवर।"],
  [213.304,213.404,"यह"],
  [213.524,213.685,"इस"],
  [213.805,214.005,"पूरे"],
  [214.125,214.345,"विषय"],
  [214.445,214.505,"का"],
  [214.645,214.945,"सबसे"],
  [215.085,215.226,"कम"],
  [215.326,215.506,"सुना"],
  [215.546,215.686,"हुआ"],
  [215.786,216.006,"शब्द"],
  [216.006,216.066,"है,"],
  [216.406,216.506,"और"],
  [216.627,216.887,"शादी"],
  [216.967,217.107,"में"],
  [217.167,217.487,"सबसे"],
  [217.507,217.907,"ज़्यादा"],
  [217.987,218.168,"काम"],
  [218.168,218.328,"आने"],
  [218.368,218.568,"वाला।"],
  [219.228,219.629,"संकल्प"],
  [219.669,219.749,"के"],
  [219.829,220.009,"समय"],
  [220.129,220.409,"पंडित"],
  [220.449,220.509,"जी"],
  [220.589,220.649,"जो"],
  [220.729,221.049,"वाक्य"],
  [221.07,221.33,"बोलते"],
  [221.41,221.59,"हैं,"],
  [221.85,222.01,"वह"],
  [222.03,222.29,"होता"],
  [222.35,222.43,"है,"],
  [222.791,223.071,"अमुक"],
  [223.191,223.591,"गोत्राय,"],
  [223.891,224.152,"अमुक"],
  [224.252,224.652,"प्रवराय।"],
  [224.652,225.633,"संकल्प"],
  [225.833,226.053,"यानी"],
  [226.193,226.433,"पूजा"],
  [226.553,226.713,"शुरू"],
  [226.793,227.014,"करने"],
  [227.094,227.174,"से"],
  [227.234,227.454,"पहले"],
  [227.574,227.794,"बोला"],
  [227.854,228.054,"जाने"],
  [228.114,228.294,"वाला"],
  [228.354,228.414,"वह"],
  [228.515,228.835,"वाक्य"],
  [229.155,229.455,"जिसमें"],
  [229.495,229.815,"बताया"],
  [229.895,230.156,"जाता"],
  [230.196,230.276,"है"],
  [230.376,230.436,"कि"],
  [230.596,230.796,"कर्म"],
  [230.896,231.076,"कौन"],
  [231.156,231.236,"सा"],
  [231.296,231.376,"हो"],
  [231.437,231.617,"रहा"],
  [231.697,231.777,"है,"],
  [232.157,232.297,"किस"],
  [232.417,232.657,"जगह"],
  [232.998,233.118,"और"],
  [233.238,233.358,"किस"],
  [233.478,233.678,"समय"],
  [233.778,233.838,"हो"],
  [233.878,234.078,"रहा"],
  [234.178,234.238,"है,"],
  [234.559,234.679,"और"],
  [234.779,234.959,"किस"],
  [235.059,235.519,"उद्देश्य"],
  [235.559,235.639,"से"],
  [235.699,235.759,"हो"],
  [235.799,236.0,"रहा"],
  [236.08,236.16,"है।"],
  [236.64,236.88,"करने"],
  [236.94,237.14,"वाले"],
  [237.22,237.3,"का"],
  [237.381,237.621,"नाम"],
  [237.621,237.821,"और"],
  [237.921,238.241,"गोत्र"],
  [238.341,238.581,"इसी"],
  [238.621,238.902,"वाक्य"],
  [238.942,239.022,"के"],
  [239.122,239.462,"भीतर"],
  [239.462,239.662,"आता"],
  [239.722,239.802,"है।"],
  [240.403,240.763,"प्रवर"],
  [240.943,241.063,"उन"],
  [241.143,241.483,"रिषियों"],
  [241.543,241.603,"के"],
  [241.663,241.944,"नामों"],
  [242.004,242.064,"की"],
  [242.084,242.184,"एक"],
  [242.304,242.564,"छोटी"],
  [242.684,242.924,"सूची"],
  [243.004,243.064,"है,"],
  [243.445,243.585,"आम"],
  [243.665,243.825,"तौर"],
  [243.905,244.025,"पर"],
  [244.125,244.365,"तीन,"],
  [244.585,244.786,"कभी"],
  [244.946,245.286,"पाँच।"],
  [245.646,245.706,"ये"],
  [245.886,245.966,"वे"],
  [246.126,246.507,"पूर्वज"],
  [246.527,246.687,"हैं"],
  [246.767,247.027,"जिनके"],
  [247.087,247.287,"नाम"],
  [247.367,247.788,"पुरोहित"],
  [247.868,248.108,"अग्नि"],
  [248.188,248.248,"के"],
  [248.348,248.628,"सामने"],
  [248.808,249.108,"आपकी"],
  [249.148,249.289,"ओर"],
  [249.349,249.409,"से"],
  [249.469,249.889,"पुकारता"],
  [249.949,250.009,"है।"],
  [250.609,250.79,"एक"],
  [250.79,251.15,"असली"],
  [251.25,251.65,"उदाहरण"],
  [251.71,252.131,"देखिए।"],
  [252.491,252.831,"भीष्म"],
  [252.891,252.971,"को"],
  [253.091,253.231,"जल"],
  [253.291,253.491,"देते"],
  [253.591,253.792,"समय"],
  [253.892,253.952,"जो"],
  [254.092,254.512,"संकल्प"],
  [254.592,254.912,"श्राद्ध"],
  [254.952,255.333,"कौस्तुभ"],
  [255.393,255.513,"में"],
  [255.573,255.813,"दर्ज"],
  [255.833,255.913,"है,"],
  [256.273,256.333,"वह"],
  [256.493,256.634,"इस"],
  [256.694,256.854,"तरह"],
  [256.954,257.214,"चलता"],
  [257.294,257.374,"है।"],
  [257.854,258.595,"वैयाघ्रपाद"],
  [258.655,258.915,"गोत्र"],
  [258.955,259.195,"वाले,"],
  [259.576,260.036,"सांकृति"],
  [260.116,260.376,"प्रवर"],
  [260.416,260.636,"वाले"],
  [260.776,261.097,"भीष्म"],
  [261.197,261.277,"को।"],
  [261.937,262.257,"गोत्र"],
  [262.498,262.698,"एक"],
  [262.758,263.018,"नाम,"],
  [263.318,264.079,"वैयाघ्रपाद।"],
  [264.379,264.719,"प्रवर"],
  [264.959,265.219,"उसके"],
  [265.339,265.56,"साथ"],
  [265.64,265.88,"चलने"],
  [265.92,266.14,"वाला,"],
  [266.4,266.86,"सांकृति।"],
  [267.361,267.501,"और"],
  [267.601,267.801,"यहीं"],
  [267.901,268.161,"समझ"],
  [268.181,268.402,"आता"],
  [268.442,268.522,"है"],
  [268.642,268.702,"कि"],
  [268.822,269.142,"गोत्र"],
  [269.262,269.622,"लाखों"],
  [269.682,269.822,"क्यों"],
  [269.842,269.923,"हो"],
  [269.983,270.103,"गए,"],
  [270.423,270.523,"और"],
  [270.623,270.903,"प्रवर"],
  [271.003,271.424,"गिने-चुने"],
  [271.504,271.644,"क्यों"],
  [271.664,271.824,"रहे।"],
  [272.424,272.985,"आपस्तंब"],
  [273.065,273.345,"श्रौत"],
  [273.405,273.645,"सूत्र"],
  [273.785,273.985,"शर्त"],
  [274.005,274.346,"लगाता"],
  [274.406,274.486,"है,"],
  [274.866,275.146,"प्रवर"],
  [275.186,275.286,"में"],
  [275.366,275.706,"पुकारे"],
  [275.787,276.007,"जाने"],
  [276.067,276.267,"वाले"],
  [276.327,276.627,"रिषि"],
  [276.747,276.947,"तीन"],
  [277.007,277.107,"हों,"],
  [277.448,277.548,"और"],
  [277.588,277.668,"वे"],
  [277.768,278.048,"मंत्र"],
  [278.188,278.488,"देखने"],
  [278.528,278.708,"वाले"],
  [278.749,278.969,"रिषि"],
  [279.049,279.149,"हों।"],
  [279.669,279.949,"गोत्र"],
  [280.009,280.069,"के"],
  [280.149,280.33,"नाम"],
  [280.39,280.51,"पर"],
  [280.61,280.83,"ऐसी"],
  [280.95,281.13,"कोई"],
  [281.23,281.43,"शर्त"],
  [281.49,281.67,"कभी"],
  [281.731,281.911,"नहीं"],
  [281.931,282.131,"लगी।"],
  [282.651,283.011,"इसीलिए"],
  [283.111,283.592,"बौधायन"],
  [283.652,283.732,"का"],
  [283.852,284.032,"वही"],
  [284.132,284.392,"ग्रंथ,"],
  [284.653,284.713,"जो"],
  [284.813,285.153,"गोत्रों"],
  [285.213,285.273,"को"],
  [285.353,285.793,"हज़ारों"],
  [285.873,285.993,"और"],
  [286.053,286.354,"लाखों"],
  [286.414,286.674,"कहता"],
  [286.714,286.794,"है,"],
  [287.134,287.414,"प्रवर"],
  [287.534,287.975,"उनचास"],
  [288.015,288.355,"गिनाता"],
  [288.415,288.495,"है।"],
  [288.755,289.316,"फ़र्क़"],
  [289.376,289.636,"सीधा"],
  [289.716,289.796,"है।"],
  [290.196,290.496,"गोत्र"],
  [290.597,290.777,"एक"],
  [290.857,291.077,"नाम"],
  [291.117,291.177,"है,"],
  [291.497,291.777,"प्रवर"],
  [291.857,292.038,"एक"],
  [292.138,292.378,"सूची"],
  [292.478,292.538,"है।"],
  [293.058,293.198,"और"],
  [293.278,293.619,"दूसरा"],
  [293.699,293.919,"शब्द।"],
  [294.199,294.599,"सपिंड।"],
  [295.1,295.44,"सपिंड"],
  [295.48,295.7,"यानी"],
  [295.86,296.1,"सीधा"],
  [296.12,296.4,"ख़ून"],
  [296.44,296.521,"का"],
  [296.561,296.821,"रिश्ता,"],
  [297.181,297.241,"जो"],
  [297.401,297.701,"पीढ़ियों"],
  [297.721,297.821,"में"],
  [297.881,298.202,"गिनकर"],
  [298.242,298.582,"निकाला"],
  [298.642,298.882,"जाता"],
  [298.942,299.022,"है।"],
  [299.523,299.803,"विष्णु"],
  [299.863,300.143,"स्मृति"],
  [300.223,300.483,"कहती"],
  [300.523,300.603,"है,"],
  [300.944,301.164,"पिता"],
  [301.244,301.344,"की"],
  [301.364,301.644,"तरफ़"],
  [301.724,301.944,"सात"],
  [302.004,302.324,"पीढ़ी,"],
  [302.525,302.645,"और"],
  [302.725,302.925,"माँ"],
  [302.945,303.005,"की"],
  [303.085,303.345,"तरफ़"],
  [303.425,303.665,"पाँच"],
  [303.705,304.206,"पीढ़ी।"],
  [304.466,304.766,"गोत्र"],
  [304.846,304.966,"और"],
  [305.046,305.326,"प्रवर"],
  [305.447,305.687,"वंश"],
  [305.747,305.807,"के"],
  [305.847,306.047,"नाम"],
  [306.087,306.267,"हैं।"],
  [306.567,306.908,"सपिंड"],
  [307.028,307.308,"असली"],
  [307.348,307.868,"रिश्तेदारी"],
  [307.948,308.008,"है।"],
  [308.549,308.689,"अब"],
  [308.789,308.869,"यह"],
  [308.989,309.129,"सब"],
  [309.189,309.369,"काम"],
  [309.489,309.769,"कहाँ"],
  [309.769,309.95,"आता"],
  [310.01,310.09,"है।"],
  [310.65,311.07,"संकल्प"],
  [311.13,311.311,"में।"],
  [311.651,312.191,"कौषीतकि"],
  [312.211,312.631,"ब्राह्मण"],
  [312.671,312.792,"में"],
  [312.852,313.092,"इसकी"],
  [313.192,313.412,"वजह"],
  [313.492,313.712,"लिखी"],
  [313.772,313.852,"है।"],
  [314.353,314.693,"देवता"],
  [314.813,315.073,"उसी"],
  [315.113,315.173,"की"],
  [315.213,315.553,"आहुति"],
  [315.633,315.974,"स्वीकार"],
  [316.034,316.274,"करते"],
  [316.334,316.494,"हैं"],
  [316.754,317.014,"जिसके"],
  [317.134,317.575,"पूर्वजों"],
  [317.615,317.675,"के"],
  [317.715,317.915,"नाम"],
  [317.995,318.335,"पुकारे"],
  [318.415,318.615,"जाएँ।"],
  [319.036,319.316,"यानी"],
  [319.456,319.736,"गोत्र"],
  [319.816,320.096,"बोलना"],
  [320.217,320.457,"पूजा"],
  [320.537,320.597,"की"],
  [320.737,320.977,"शर्त"],
  [321.057,321.137,"थी।"],
  [321.718,321.878,"अब"],
  [321.978,322.338,"विवाह।"],
  [322.898,323.479,"मनुस्मृति"],
  [323.619,323.799,"एक"],
  [323.859,324.039,"बात"],
  [324.059,324.319,"कहती"],
  [324.379,324.459,"है,"],
  [324.88,325.14,"अपने"],
  [325.2,325.26,"ही"],
  [325.36,325.6,"गोत्र"],
  [325.64,325.78,"में"],
  [325.82,326.101,"विवाह"],
  [326.121,326.641,"वर्जित।"],
  [327.001,327.281,"विष्णु"],
  [327.341,327.642,"स्मृति"],
  [327.782,327.982,"तीन"],
  [328.022,328.322,"बातें"],
  [328.322,328.682,"अलग-अलग"],
  [328.722,329.043,"गिनाती"],
  [329.103,329.183,"है।"],
  [329.603,329.923,"समान"],
  [329.983,330.243,"गोत्र"],
  [330.303,330.704,"वर्जित।"],
  [330.984,331.284,"समान"],
  [331.364,331.644,"प्रवर"],
  [331.644,332.085,"वर्जित।"],
  [332.365,332.705,"सपिंड"],
  [332.745,333.125,"वर्जित।"],
  [333.586,333.826,"यानी"],
  [333.946,334.206,"शादी"],
  [334.286,334.386,"में"],
  [334.546,334.726,"तीन"],
  [334.786,335.027,"जाँच"],
  [335.047,335.247,"होती"],
  [335.327,335.427,"थीं।"],
  [335.867,336.187,"गोत्र,"],
  [336.367,336.688,"प्रवर,"],
  [336.828,336.968,"और"],
  [337.088,337.488,"सपिंड।"],
  [337.929,338.289,"बीसवीं"],
  [338.349,338.589,"सदी"],
  [338.589,338.709,"में"],
  [338.829,339.51,"धर्मशास्त्र"],
  [339.57,339.65,"का"],
  [339.83,340.11,"सबसे"],
  [340.17,340.33,"बड़ा"],
  [340.35,340.81,"इतिहास"],
  [340.851,341.111,"लिखने"],
  [341.151,341.351,"वाले"],
  [341.511,341.571,"पी"],
  [341.671,341.731,"वी"],
  [341.851,342.091,"काणे"],
  [342.452,342.712,"इसका"],
  [342.712,342.832,"एक"],
  [342.872,343.232,"उदाहरण"],
  [343.272,343.492,"देते"],
  [343.532,343.632,"हैं।"],
  [344.053,344.433,"यास्क,"],
  [344.733,345.173,"वाधूल,"],
  [345.454,345.734,"मौन"],
  [345.994,346.114,"और"],
  [346.194,346.494,"मौक।"],
  [346.875,346.975,"इन"],
  [347.115,347.375,"चारों"],
  [347.435,347.495,"के"],
  [347.595,347.875,"गोत्र"],
  [347.995,348.236,"आपस"],
  [348.276,348.356,"में"],
  [348.436,348.656,"अलग"],
  [348.696,348.776,"हैं।"],
  [349.136,349.316,"फिर"],
  [349.376,349.436,"भी"],
  [349.496,349.656,"इनमें"],
  [349.717,349.957,"विवाह"],
  [350.037,350.377,"वर्जित"],
  [350.377,350.437,"है,"],
  [350.837,351.097,"क्योंकि"],
  [351.198,351.518,"प्रवर"],
  [351.678,351.938,"चारों"],
  [351.978,352.058,"का"],
  [352.138,352.278,"एक"],
  [352.338,352.398,"ही"],
  [352.498,352.578,"है।"],
  [352.999,353.479,"भार्गव,"],
  [353.739,354.32,"वैतहव्य,"],
  [354.62,355.28,"सावेतस।"],
  [355.801,356.001,"आज"],
  [356.061,356.341,"रिश्ता"],
  [356.461,356.581,"तय"],
  [356.661,356.901,"करते"],
  [356.961,357.162,"समय"],
  [357.242,358.002,"ज़्यादातर"],
  [358.062,358.302,"घरों"],
  [358.322,358.402,"में"],
  [358.522,358.843,"सिर्फ़"],
  [358.843,359.003,"पहली"],
  [359.083,359.323,"जाँच"],
  [359.323,359.523,"होती"],
  [359.583,359.663,"है।"],
  [360.184,360.324,"अब"],
  [360.404,360.484,"वह"],
  [360.504,360.864,"हिस्सा"],
  [361.024,361.324,"जिसमें"],
  [361.364,361.725,"विज्ञान"],
  [361.785,361.845,"की"],
  [361.885,362.105,"बात"],
  [362.105,362.285,"आती"],
  [362.345,362.425,"है।"],
  [362.925,363.106,"एक"],
  [363.166,363.406,"बात"],
  [363.506,363.646,"हर"],
  [363.686,363.926,"जगह"],
  [363.966,364.186,"सुनने"],
  [364.226,364.306,"को"],
  [364.326,364.567,"मिलती"],
  [364.627,364.707,"है।"],
  [365.147,365.487,"रिषियों"],
  [365.547,365.607,"को"],
  [365.727,366.028,"डीएनए"],
  [366.088,366.168,"का"],
  [366.268,366.488,"ज्ञान"],
  [366.568,366.668,"था,"],
  [367.048,367.408,"इसीलिए"],
  [367.549,367.829,"गोत्र"],
  [367.869,368.149,"बनाया"],
  [368.229,368.389,"गया।"],
  [368.869,368.95,"तो"],
  [369.07,369.15,"दो"],
  [369.25,369.53,"तरफ़"],
  [369.53,369.59,"से"],
  [369.63,369.91,"देखते"],
  [369.95,370.05,"हैं।"],
  [370.431,370.751,"शास्त्र"],
  [370.851,371.051,"इसका"],
  [371.131,371.371,"कारण"],
  [371.451,371.571,"क्या"],
  [371.651,371.992,"बताता"],
  [372.032,372.092,"है,"],
  [372.432,372.552,"और"],
  [372.652,372.852,"आज"],
  [372.892,372.972,"का"],
  [373.012,373.312,"विज्ञान"],
  [373.373,373.473,"क्या"],
  [373.533,373.793,"कहता"],
  [373.853,373.933,"है।"],
  [374.513,374.813,"शास्त्र"],
  [374.874,374.954,"की"],
  [374.994,375.254,"तरफ़"],
  [375.274,375.374,"से।"],
  [375.894,376.134,"चरक"],
  [376.194,376.515,"संहिता"],
  [376.615,376.675,"के"],
  [376.795,377.415,"शारीरस्थान"],
  [377.475,377.555,"का"],
  [377.655,377.956,"दूसरा"],
  [377.996,378.376,"अध्याय"],
  [378.376,378.456,"है,"],
  [378.816,378.936,"और"],
  [378.976,379.236,"उसका"],
  [379.317,379.557,"नाम"],
  [379.557,379.637,"ही"],
  [379.717,379.797,"है"],
  [380.017,380.778,"अतुल्यगोत्रीय"],
  [380.898,381.238,"शारीर,"],
  [381.578,381.818,"यानी"],
  [381.978,382.198,"भिन्न"],
  [382.299,382.599,"गोत्र।"],
  [383.079,383.439,"ग्यारहवीं"],
  [383.479,383.74,"सदी"],
  [383.76,383.82,"के"],
  [383.92,384.38,"आचार्य"],
  [384.44,385.281,"चक्रपाणिदत्त"],
  [385.281,385.361,"ने"],
  [385.721,385.921,"इसी"],
  [386.001,386.241,"श्लोक"],
  [386.301,386.421,"पर"],
  [386.481,386.762,"कारण"],
  [386.782,387.022,"लिखा"],
  [387.082,387.142,"है।"],
  [387.662,387.982,"समान"],
  [388.062,388.323,"गोत्र"],
  [388.363,388.503,"में"],
  [388.543,388.903,"संबंध"],
  [389.003,389.343,"अधर्म"],
  [389.403,389.483,"है,"],
  [389.824,390.124,"इसलिए"],
  [390.264,390.884,"धर्मशास्त्र"],
  [390.904,390.984,"में"],
  [391.064,391.365,"वर्जित"],
  [391.385,391.485,"है।"],
  [392.145,392.365,"यानी"],
  [392.505,392.906,"शास्त्र"],
  [393.066,393.326,"अपना"],
  [393.426,393.686,"कारण"],
  [393.786,393.986,"धर्म"],
  [394.046,394.127,"के"],
  [394.187,394.427,"खाते"],
  [394.427,394.547,"में"],
  [394.547,394.827,"रखता"],
  [394.867,394.947,"है।"],
  [395.467,395.608,"अब"],
  [395.708,395.908,"आज"],
  [395.948,396.008,"का"],
  [396.068,396.448,"विज्ञान।"],
  [396.868,397.329,"नज़दीकी"],
  [397.349,397.629,"ख़ून"],
  [397.689,397.749,"के"],
  [397.789,398.089,"रिश्ते"],
  [398.109,398.209,"में"],
  [398.209,398.53,"विवाह"],
  [398.61,398.69,"का"],
  [398.77,399.07,"जोखिम"],
  [399.11,399.37,"मापा"],
  [399.43,399.51,"जा"],
  [399.59,399.79,"चुका"],
  [399.85,399.91,"है।"],
  [400.371,400.611,"बड़े"],
  [400.651,401.211,"अध्ययनों"],
  [401.231,401.331,"में"],
  [401.652,401.732,"यह"],
  [401.812,402.152,"लगभग"],
  [402.272,402.492,"एक"],
  [402.552,402.612,"से"],
  [402.772,402.973,"साढ़े"],
  [403.053,403.193,"तीन"],
  [403.233,403.573,"प्रतिशत"],
  [403.653,403.773,"तक"],
  [403.813,404.053,"ज़्यादा"],
  [404.093,404.393,"बैठता"],
  [404.434,404.514,"है।"],
  [404.914,405.034,"और"],
  [405.134,405.214,"यह"],
  [405.334,405.674,"जोखिम"],
  [405.834,405.995,"इस"],
  [406.035,406.215,"बात"],
  [406.255,406.335,"से"],
  [406.395,406.515,"तय"],
  [406.595,406.815,"होता"],
  [406.875,406.955,"है"],
  [407.075,407.135,"कि"],
  [407.215,407.496,"माता"],
  [407.596,407.696,"और"],
  [407.756,407.956,"पिता"],
  [408.036,408.116,"का"],
  [408.196,408.416,"ख़ून"],
  [408.676,408.957,"आपस"],
  [408.977,409.077,"में"],
  [409.157,409.417,"कितना"],
  [409.457,409.837,"नज़दीक"],
  [409.857,409.937,"है।"],
  [410.418,410.538,"और"],
  [410.658,410.938,"गोत्र"],
  [411.058,411.258,"पिता"],
  [411.378,411.458,"से"],
  [411.598,411.839,"पुत्र"],
  [411.899,411.999,"तक"],
  [412.059,412.299,"चलता"],
  [412.339,412.419,"है।"],
  [412.939,413.3,"इसलिए"],
  [413.72,413.84,"माँ"],
  [413.98,414.04,"की"],
  [414.1,414.36,"तरफ़"],
  [414.36,414.42,"के"],
  [414.52,414.72,"सगे"],
  [414.801,414.961,"भाई"],
  [414.981,415.221,"बहन"],
  [415.261,415.341,"के"],
  [415.401,415.721,"बच्चों"],
  [415.741,415.801,"का"],
  [415.901,416.161,"गोत्र"],
  [416.282,416.562,"आपस"],
  [416.602,416.682,"में"],
  [416.802,417.022,"अलग"],
  [417.042,417.262,"होता"],
  [417.322,417.382,"है,"],
  [417.763,417.883,"और"],
  [417.923,417.983,"वे"],
  [418.123,418.383,"गोत्र"],
  [418.423,418.703,"मिलान"],
  [418.723,418.803,"में"],
  [418.903,419.123,"पास"],
  [419.123,419.183,"हो"],
  [419.244,419.464,"जाते"],
  [419.524,419.604,"हैं।"],
  [420.164,420.424,"काणे"],
  [420.544,420.725,"इसे"],
  [420.865,421.125,"साफ़"],
  [421.145,421.325,"दर्ज"],
  [421.365,421.605,"करते"],
  [421.665,421.845,"हैं।"],
  [422.286,422.626,"सपिंड"],
  [422.646,423.146,"रिश्तेदार"],
  [423.326,423.566,"एक"],
  [423.566,423.647,"ही"],
  [423.687,423.947,"गोत्र"],
  [424.007,424.067,"के"],
  [424.167,424.367,"भी"],
  [424.387,424.447,"हो"],
  [424.527,424.767,"सकते"],
  [424.807,424.967,"हैं,"],
  [425.188,425.328,"और"],
  [425.448,425.668,"अलग"],
  [425.708,425.948,"गोत्र"],
  [426.008,426.068,"के"],
  [426.148,426.228,"भी।"],
  [426.869,427.189,"दक्षिण"],
  [427.249,427.509,"भारत"],
  [427.549,427.609,"की"],
  [427.729,427.869,"कई"],
  [427.969,428.45,"परंपराओं"],
  [428.47,428.57,"में"],
  [428.89,429.15,"मामा"],
  [429.25,429.31,"की"],
  [429.37,429.591,"बेटी"],
  [429.671,429.731,"से"],
  [429.791,430.111,"विवाह"],
  [430.231,430.431,"आज"],
  [430.471,430.531,"भी"],
  [430.591,430.971,"प्रचलित"],
  [430.971,431.031,"है,"],
  [431.472,431.592,"और"],
  [431.692,431.772,"वह"],
  [431.972,432.232,"गोत्र"],
  [432.312,432.372,"की"],
  [432.472,432.713,"जाँच"],
  [432.733,432.813,"में"],
  [432.953,433.193,"पूरा"],
  [433.253,433.433,"पास"],
  [433.493,433.793,"बैठता"],
  [433.833,433.913,"है।"],
  [434.594,435.014,"इसीलिए"],
  [435.214,435.475,"तीनों"],
  [435.535,435.715,"जाँच"],
  [435.775,435.975,"बनाई"],
  [436.055,436.155,"गई"],
  [436.235,436.355,"थीं।"],
  [436.915,437.216,"गोत्र"],
  [437.316,437.516,"नाम"],
  [437.576,437.916,"पकड़ता"],
  [437.976,438.056,"है,"],
  [438.416,438.737,"सपिंड"],
  [438.877,439.097,"ख़ून"],
  [439.157,439.497,"पकड़ता"],
  [439.557,439.637,"है।"],
  [440.298,440.518,"एक"],
  [440.558,440.758,"जगह"],
  [440.898,441.258,"विज्ञान"],
  [441.338,441.699,"परंपरा"],
  [441.779,441.859,"के"],
  [441.979,442.359,"साथ-साथ"],
  [442.459,442.719,"चलता"],
  [442.719,443.08,"ज़रूर"],
  [443.12,443.36,"मिलता"],
  [443.42,443.5,"है।"],
  [444.08,444.361,"गोत्र"],
  [444.461,444.661,"पिता"],
  [444.761,444.841,"से"],
  [444.961,445.201,"पुत्र"],
  [445.241,445.361,"तक"],
  [445.421,445.661,"चलता"],
  [445.701,445.781,"है,"],
  [445.842,446.282,"और"],
  [446.402,446.702,"शरीर"],
  [446.722,446.822,"में"],
  [446.862,447.222,"वाई"],
  [447.282,447.763,"क्रोमोसोम"],
  [447.803,447.863,"भी"],
  [447.963,448.203,"ठीक"],
  [448.303,448.483,"उसी"],
  [448.523,448.804,"रास्ते"],
  [448.864,449.104,"चलता"],
  [449.144,449.224,"है।"],
  [449.784,450.325,"क्रोमोसोम"],
  [450.405,450.605,"यानी"],
  [450.745,450.825,"वह"],
  [450.945,451.205,"धागा"],
  [451.545,451.705,"जिस"],
  [451.725,451.826,"पर"],
  [451.866,452.166,"हमारे"],
  [452.286,452.546,"शरीर"],
  [452.586,452.646,"की"],
  [452.826,453.026,"सारी"],
  [453.126,453.507,"जानकारी"],
  [453.587,453.807,"लिखी"],
  [453.867,454.087,"होती"],
  [454.127,454.207,"है।"],
  [454.888,455.068,"और"],
  [455.208,455.288,"वह"],
  [455.428,455.688,"बात"],
  [455.748,455.828,"जो"],
  [455.948,456.128,"हर"],
  [456.209,456.349,"घर"],
  [456.389,456.489,"में"],
  [456.629,456.849,"उल्टी"],
  [456.909,457.149,"बताई"],
  [457.209,457.429,"जाती"],
  [457.469,457.549,"है।"],
  [458.13,458.59,"सगोत्र"],
  [458.63,458.97,"विवाह"],
  [459.03,459.391,"भारत"],
  [459.391,459.471,"में"],
  [459.611,459.851,"वैध"],
  [459.871,459.951,"है।"],
  [460.531,460.792,"हिंदू"],
  [460.872,461.112,"विवाह"],
  [461.232,461.752,"निर्योग्यता"],
  [461.832,462.193,"निवारण"],
  [462.273,462.753,"अधिनियम,"],
  [463.033,463.173,"सन"],
  [463.293,463.574,"उन्नीस"],
  [463.614,463.674,"सौ"],
  [463.794,464.194,"छियालीस,"],
  [464.234,464.334,"ने"],
  [464.614,464.814,"इसे"],
  [464.974,465.235,"साफ़"],
  [465.275,465.535,"शब्दों"],
  [465.555,465.655,"में"],
  [465.655,465.995,"वैध"],
  [466.075,466.455,"ठहराया।"],
  [466.996,467.196,"और"],
  [467.256,467.516,"हिंदू"],
  [467.576,467.876,"विवाह"],
  [467.936,468.377,"अधिनियम"],
  [468.437,468.497,"की"],
  [468.577,468.837,"धारा"],
  [468.977,469.257,"पाँच"],
  [469.558,469.918,"सपिंड"],
  [469.998,470.138,"और"],
  [470.178,470.558,"निषिद्ध"],
  [470.598,470.898,"रिश्तों"],
  [470.959,471.019,"की"],
  [471.119,471.359,"डिग्री"],
  [471.419,471.539,"पर"],
  [471.579,471.819,"चलती"],
  [471.899,471.979,"है।"],
  [472.66,472.76,"जो"],
  [472.88,473.12,"नियम"],
  [473.24,473.5,"पूजा"],
  [473.56,473.64,"में"],
  [473.72,474.121,"पहचान"],
  [474.161,474.461,"बताने"],
  [474.501,474.561,"के"],
  [474.581,474.681,"लिए"],
  [474.721,474.861,"बना"],
  [474.961,475.061,"था,"],
  [475.462,475.622,"कुछ"],
  [475.722,476.002,"जगहों"],
  [476.062,476.182,"पर"],
  [476.282,476.462,"उसे"],
  [476.582,476.802,"दंड"],
  [476.862,476.943,"का"],
  [477.003,477.423,"हथियार"],
  [477.463,477.623,"बना"],
  [477.683,477.823,"दिया"],
  [477.883,478.023,"गया।"],
  [478.584,478.824,"खाप"],
  [478.924,479.444,"पंचायतों"],
  [479.484,479.564,"का"],
  [479.704,479.784,"यह"],
  [479.885,480.105,"रूप"],
  [480.285,480.625,"बीसवीं"],
  [480.665,480.845,"सदी"],
  [480.885,480.965,"में"],
  [481.005,481.185,"खड़ा"],
  [481.245,481.406,"हुआ"],
  [481.486,481.566,"है।"],
  [482.106,482.206,"यह"],
  [482.346,482.907,"लोकाचार"],
  [482.907,483.007,"है।"],
  [483.647,483.707,"तो"],
  [483.827,484.067,"अगली"],
  [484.127,484.268,"बार"],
  [484.368,484.648,"पंडित"],
  [484.688,484.748,"जी"],
  [484.828,485.168,"पूछें,"],
  [485.368,485.428,"तो"],
  [485.568,485.708,"क्या"],
  [485.789,485.989,"कहें।"],
  [486.409,486.489,"जो"],
  [486.589,486.829,"आपके"],
  [486.909,487.049,"घर"],
  [487.089,487.169,"में"],
  [487.27,487.47,"चला"],
  [487.49,487.53,"आ"],
  [487.63,487.83,"रहा"],
  [487.87,487.95,"है,"],
  [488.05,488.21,"वही"],
  [488.29,488.57,"कहिए।"],
  [488.971,489.191,"अगर"],
  [489.231,489.311,"वह"],
  [489.371,489.611,"रिषि"],
  [489.671,489.751,"का"],
  [489.791,489.991,"नाम"],
  [490.011,490.091,"है,"],
  [490.252,490.332,"तो"],
  [490.412,490.552,"वह"],
  [490.612,490.752,"सही"],
  [490.832,491.132,"जवाब"],
  [491.152,491.212,"है।"],
  [491.632,491.833,"अगर"],
  [491.893,491.993,"वह"],
  [492.033,492.293,"आपके"],
  [492.293,492.573,"कुल"],
  [492.633,492.693,"का"],
  [492.753,492.933,"नाम"],
  [492.973,493.053,"है,"],
  [493.194,493.434,"जैसे"],
  [493.494,493.934,"कटारिया,"],
  [494.254,494.334,"तो"],
  [494.434,494.514,"वह"],
  [494.615,494.675,"भी"],
  [494.795,495.055,"उतना"],
  [495.095,495.155,"ही"],
  [495.275,495.415,"सही"],
  [495.495,495.795,"जवाब"],
  [495.815,495.875,"है।"],
  [496.396,496.516,"और"],
  [496.596,496.836,"जिन्हें"],
  [496.876,497.096,"अपना"],
  [497.196,497.456,"गोत्र"],
  [497.516,497.817,"मालूम"],
  [497.837,498.057,"नहीं,"],
  [498.057,498.457,"उनके"],
  [498.497,498.617,"लिए"],
  [498.677,498.737,"भी"],
  [498.797,499.238,"व्यवस्था"],
  [499.298,499.378,"है।"],
  [499.798,500.238,"संस्कार"],
  [500.318,500.699,"कौस्तुभ"],
  [500.719,500.979,"कहता"],
  [501.059,501.119,"है,"],
  [501.339,501.399,"वे"],
  [501.519,501.699,"ख़ुद"],
  [501.759,501.839,"को"],
  [501.979,502.24,"कश्यप"],
  [502.34,502.56,"गोत्र"],
  [502.62,502.84,"का"],
  [502.84,502.98,"कहें।"],
  [503.46,503.581,"और"],
  [503.681,503.861,"इसी"],
  [503.961,504.241,"सवाल"],
  [504.301,504.381,"का"],
  [504.521,504.821,"सबसे"],
  [504.901,505.202,"पुराना"],
  [505.282,505.582,"जवाब"],
  [505.682,506.162,"छांदोग्य"],
  [506.222,506.623,"उपनिषद"],
  [506.643,506.763,"में"],
  [506.763,507.023,"रखा"],
  [507.123,507.183,"है।"],
  [507.643,508.184,"सत्यकाम"],
  [508.244,508.464,"अपनी"],
  [508.524,508.784,"माता"],
  [508.864,508.924,"से"],
  [509.024,509.344,"पूछते"],
  [509.405,509.545,"हैं,"],
  [509.645,509.865,"मेरा"],
  [509.965,510.245,"गोत्र"],
  [510.305,510.445,"क्या"],
  [510.525,510.585,"है।"],
  [511.006,511.266,"माता"],
  [511.346,511.546,"बता"],
  [511.606,511.766,"नहीं"],
  [511.826,512.186,"पातीं।"],
  [512.527,513.007,"सत्यकाम"],
  [513.067,513.287,"गुरु"],
  [513.307,513.367,"के"],
  [513.367,513.707,"पास"],
  [513.727,513.968,"जाते"],
  [514.028,514.168,"हैं"],
  [514.268,514.388,"और"],
  [514.468,514.628,"यही"],
  [514.808,514.988,"सच"],
  [515.068,515.208,"कह"],
  [515.268,515.509,"देते"],
  [515.569,515.669,"हैं।"],
  [516.149,516.349,"गुरु"],
  [516.449,516.669,"उन्हें"],
  [516.749,517.05,"शिष्य"],
  [517.05,517.23,"बना"],
  [517.27,517.51,"लेते"],
  [517.57,517.65,"हैं।"],
  [517.99,518.23,"रिषि"],
  [518.291,518.371,"का"],
  [518.391,518.591,"नाम"],
  [518.631,518.971,"बताने"],
  [519.051,519.171,"पर"],
  [519.191,519.391,"नहीं।"],
  [519.711,519.912,"सच"],
  [520.032,520.332,"बोलने"],
  [520.432,520.652,"पर।"],
  [521.012,521.212,"एक"],
  [521.253,521.473,"बात"],
  [521.473,521.713,"हमें"],
  [521.773,521.993,"आज"],
  [522.053,522.193,"तक"],
  [522.213,522.413,"नहीं"],
  [522.433,522.613,"मिली।"],
  [523.114,523.194,"यह"],
  [523.354,523.514,"एक"],
  [523.514,523.654,"ही"],
  [523.734,523.934,"ब्लड"],
  [523.974,524.114,"ग्रुप"],
  [524.174,524.375,"वाली"],
  [524.455,524.695,"बात"],
  [524.815,524.995,"शुरू"],
  [525.095,525.275,"कहाँ"],
  [525.375,525.455,"से"],
  [525.515,525.676,"हुई,"],
  [525.716,526.076,"इसका"],
  [526.196,526.376,"कोई"],
  [526.416,526.756,"स्रोत"],
  [526.756,527.056,"हमारे"],
  [527.136,527.337,"हाथ"],
  [527.377,527.577,"नहीं"],
  [527.617,527.817,"लगा।"],
  [528.237,528.517,"अगर"],
  [528.517,528.778,"आपको"],
  [528.798,529.118,"मालूम"],
  [529.158,529.218,"है"],
  [529.358,529.418,"कि"],
  [529.518,529.618,"यह"],
  [529.698,529.898,"बात"],
  [529.958,530.159,"कहाँ"],
  [530.239,530.299,"से"],
  [530.399,530.559,"शुरू"],
  [530.639,530.779,"हुई,"],
  [530.879,530.959,"तो"],
  [531.039,531.319,"कमेंट"],
  [531.359,531.6,"बॉक्स"],
  [531.62,531.74,"में"],
  [531.74,532.04,"ज़रूर"],
  [532.08,532.4,"बताएँ।"],
  [532.7,532.88,"इस"],
  [532.9,533.301,"एपिसोड"],
  [533.341,533.401,"के"],
  [533.521,533.741,"सारे"],
  [533.861,534.281,"संदर्भ,"],
  [534.582,534.782,"कौन"],
  [534.842,534.962,"सी"],
  [534.982,535.202,"बात"],
  [535.242,535.422,"किस"],
  [535.482,535.742,"ग्रंथ"],
  [535.782,535.902,"में"],
  [535.942,536.023,"है,"],
  [536.203,536.523,"हमारे"],
  [536.523,537.023,"व्हाट्सएप"],
  [537.023,537.263,"चैनल"],
  [537.303,537.443,"पर"],
  [537.463,537.664,"हैं।"],
  [537.944,538.184,"लिंक"],
  [538.224,538.504,"नीचे"],
  [538.564,538.644,"है।"],
  [539.225,539.545,"सजग"],
  [539.545,539.825,"रहिए,"],
  [539.985,540.185,"जुड़े"],
  [540.245,540.506,"रहिए,"],
  [540.766,541.086,"जानते"],
  [541.126,541.406,"रहिए।"],
  [541.646,542.227,"धन्यवाद।"],
  [542.587,542.767,"हर"],
  [542.827,542.987,"हर"],
  [543.047,543.628,"महादेव।"],
];
export const SEG: {i:number;start:number;end:number;w0:number;n:number}[] = [
  {i:0, start:0.3, end:6.765, w0:0, n:19},
  {i:1, start:7.225, end:15.43, w0:19, n:27},
  {i:2, start:15.951, end:29.28, w0:46, n:43},
  {i:3, start:29.94, end:38.146, w0:89, n:27},
  {i:4, start:38.706, end:42.869, w0:116, n:13},
  {i:5, start:43.469, end:53.536, w0:129, n:34},
  {i:6, start:54.137, end:60.781, w0:163, n:19},
  {i:7, start:61.422, end:67.726, w0:182, n:17},
  {i:8, start:68.186, end:77.833, w0:199, n:34},
  {i:9, start:78.493, end:80.214, w0:233, n:7},
  {i:10, start:80.655, end:85.798, w0:240, n:18},
  {i:11, start:86.398, end:92.142, w0:258, n:19},
  {i:12, start:92.683, end:101.168, w0:277, n:30},
  {i:13, start:101.729, end:104.411, w0:307, n:8},
  {i:14, start:104.971, end:115.418, w0:315, n:30},
  {i:15, start:115.998, end:123.884, w0:345, n:24},
  {i:16, start:124.504, end:131.789, w0:369, n:22},
  {i:17, start:132.41, end:137.493, w0:391, n:16},
  {i:18, start:137.853, end:146.839, w0:407, n:30},
  {i:19, start:147.26, end:151.923, w0:437, n:15},
  {i:20, start:152.483, end:160.288, w0:452, n:20},
  {i:21, start:160.929, end:170.816, w0:472, n:32},
  {i:22, start:171.396, end:178.681, w0:504, n:17},
  {i:23, start:179.241, end:181.563, w0:521, n:7},
  {i:24, start:182.103, end:187.647, w0:528, n:23},
  {i:25, start:188.167, end:201.416, w0:551, n:47},
  {i:26, start:202.017, end:208.681, w0:598, n:24},
  {i:27, start:209.121, end:218.568, w0:622, n:32},
  {i:28, start:219.228, end:239.802, w0:654, n:66},
  {i:29, start:240.403, end:250.009, w0:720, n:31},
  {i:30, start:250.609, end:266.86, w0:751, n:39},
  {i:31, start:267.361, end:288.495, w0:790, n:64},
  {i:32, start:288.755, end:292.538, w0:854, n:11},
  {i:33, start:293.058, end:294.599, w0:865, n:4},
  {i:34, start:295.1, end:308.008, w0:869, n:39},
  {i:35, start:308.549, end:310.09, w0:908, n:7},
  {i:36, start:310.65, end:321.137, w0:915, n:29},
  {i:37, start:321.718, end:322.338, w0:944, n:2},
  {i:38, start:322.898, end:333.125, w0:946, n:26},
  {i:39, start:333.586, end:337.488, w0:972, n:11},
  {i:40, start:337.929, end:355.28, w0:983, n:47},
  {i:41, start:355.801, end:359.663, w0:1030, n:13},
  {i:42, start:360.184, end:362.425, w0:1043, n:9},
  {i:43, start:362.925, end:373.933, w0:1052, n:37},
  {i:44, start:374.513, end:382.599, w0:1089, n:22},
  {i:45, start:383.079, end:391.485, w0:1111, n:23},
  {i:46, start:392.145, end:394.947, w0:1134, n:10},
  {i:47, start:395.467, end:409.937, w0:1144, n:50},
  {i:48, start:410.418, end:433.913, w0:1194, n:80},
  {i:49, start:434.594, end:439.637, w0:1274, n:14},
  {i:50, start:440.298, end:454.207, w0:1288, n:42},
  {i:51, start:454.888, end:471.979, w0:1330, n:49},
  {i:52, start:472.66, end:483.007, w0:1379, n:34},
  {i:53, start:483.647, end:485.989, w0:1413, n:9},
  {i:54, start:486.409, end:495.875, w0:1422, n:38},
  {i:55, start:496.396, end:502.98, w0:1460, n:22},
  {i:56, start:503.46, end:515.669, w0:1482, n:38},
  {i:57, start:516.149, end:520.652, w0:1520, n:15},
  {i:58, start:521.012, end:532.4, w0:1535, n:42},
  {i:59, start:532.7, end:538.644, w0:1577, n:20},
  {i:60, start:539.225, end:542.227, w0:1597, n:7},
  {i:61, start:542.587, end:543.628, w0:1604, n:3},
];
/** [start,end] of a run of words */
export const span = (a:number,b:number):[number,number] => [WD[a][0], WD[b][1]];
/** word indices of segment i */
export const sw = (i:number) => { const s=SEG[i]; return [s.w0, s.w0+s.n-1] as [number,number]; };
/** find the index of a phrase inside a segment; -1 if absent */
export const find = (segI:number, phrase:string) => {
  const s = SEG[segI]; const t = phrase.split(' ');
  const norm = (x:string) => x.replace(/[।,.!?"'()]/g,'');
  for (let k=0;k<s.n-t.length+1;k++) {
    let ok=true;
    for (let j=0;j<t.length;j++) if (norm(WD[s.w0+k+j][2])!==norm(t[j])) { ok=false; break; }
    if (ok) return s.w0+k;
  }
  return -1;
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
